module.exports = __webpack_public_path__ + "components/weather-icon/static/nightriskshowers-991edccfc63aba81d566caea35f3b55e.svg";